<template>
  <div>
    <ul class="news-list" :class="{'sub-page': isSubPage}">
      <li v-for="row in list" :key="row.contentItemId" @click='toDetails(row)'>
        <div class="pic-model">
          <img class="pic" :src="getPictureUrl(row)"/>
          <img v-if="getVideo(row)" class="pic-play-btn" :src="playBtnPic"/>
        </div>
        <div class='content'>
          <div class='list-date'>{{row.sCreateTime}}</div>
          <div class='list-title'>{{row.newsTitle}}</div>
          <div class='list-tags'>
            <div v-for="tag in row.fileItemTags" :key="tag.tagId" class='tag'>{{tag.tagName}}</div>
          </div>
          <div class='list-btns'>
            <button class='mc-common-btn small'>查看更多</button>
            <button v-if="row.fileLists.length>0" class='mc-common-btn small' @click.stop='handleDownload(row)'>下载新闻稿</button>
          </div>
        </div>
      </li>
    </ul>

    <message-box v-if="registerSuccessMsgShow" @close="registerSuccessMsgShow=false">
      <template slot="context">注册待审中<br/>我们将尽快审核您的申请，<br/>并告诉您审核结果</template>
    </message-box>
  </div>
</template>

<script>
import {isWechatBrowser,downloadUrlFile} from "@/utilities/tools";
import MessageBox from "../../components/MediaCenter/MessageBox";

export default {
  name: "NewsList",
  components: {MessageBox},
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    isSubPage: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  data() {
    return {
      playBtnPic: require("@/assets/MediaCenter/playBtn.png"),
      registerSuccessMsgShow: false
    }
  },
  methods: {
    toDetails({contentItemId}){
      this.$router.push({
        name: "DownloadDetails",
        params: {
          id: contentItemId
        }
      })
    },
    getPictureUrl({newsPictureUrl, fileLists}) {
      let file = fileLists[0];
      let imgUrl = null;
      if(file && file.reviewImageUrl) {
        imgUrl = file.reviewImageUrl;
      } else if(file && file.videoBgImageUrl) {
        imgUrl = file.videoBgImageUrl;
      } else {
        imgUrl = newsPictureUrl;
      }
      return imgUrl;
    },
    getVideo({fileLists}) {
      return fileLists[0] && fileLists[0].videoBgImageUrl;
    },
    handleDownload(row) {
      let fileUrl = row.fileLists[0].fileUrl;
      let fileName = row.fileLists[0].fileName;
      let isAllowDownload = row.fileLists[0].isAllowDownload;
      if(localStorage.getItem('dUserToken')) {
        if(!isAllowDownload) {
          this.registerSuccessMsgShow = true;
          return;
        }
      } else {
        const redirectUrl = encodeURIComponent(this.$route.path);
        this.$router.push("/Rccl.CustomPage/MediaCenter/MediaLogin?redirectUrl="+redirectUrl);
        return;
      }
      if(!isWechatBrowser()) {
        downloadUrlFile(fileUrl, fileName, this.$loading);
      }
    }
  }
}
</script>

<style lang="less" scoped>
/*新闻列表*/
.news-list {
  margin-top: 11px;
  &.sub-page {
    margin-top: 0;
    & li:first-child {
      border-top: none;
    }
  }

  & li {
    display: grid;
    grid-template-columns: 91.5px auto;
    padding: 18px 0;
    border-top: 1px solid #ececef;
    &:first-child {
      border-top: none;
    }
    & .pic-model {
      position: relative;
      width: 91.5px;
      height: 91.5px;
      overflow: hidden;
      & .pic {
        position: absolute;
        top: 0;
        left: 50%;
        width: auto;
        transform: translateX(-50%);
        height: 100%;
      }
      & .pic-play-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        z-index: 1;
        width: 40px;
        height: 40px;
        opacity: .7;
      }
    }
    & .content {
      margin-left: 16px;
    }
  }
}
</style>
